import { render, staticRenderFns } from "./addPersonalAccountData.vue?vue&type=template&id=3defa3d0&scoped=true&"
import script from "./addPersonalAccountData.vue?vue&type=script&lang=js&"
export * from "./addPersonalAccountData.vue?vue&type=script&lang=js&"
import style0 from "./addPersonalAccountData.vue?vue&type=style&index=0&id=3defa3d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3defa3d0",
  null
  
)

export default component.exports